import React, { useState } from 'react';
import { CustomLink, Body, Caption, styled } from '@teko/ds-desktop';
import { getComboImageUrl, getComboName } from '../../helpers/index.es.js';
import { EnhancedImage } from '@teko/teko-ecommerce';
import { Tag } from '@teko/ds-foundation';
import { ComboImage } from '../ComboImage/ComboImage.es.js';
import { Variants } from '../Variants/Variants.es.js';
import { DropdownToggle } from '../Dropdown/DropdownToggle.es.js';
import { DropdownMenu } from '../Dropdown/DropdownMenu.es.js';
import { Dropdown } from '../Dropdown/Dropdown.es.js';
import { Gift } from '../Gift/Gift.es.js';

const ProductInfo = ({ product: { sku, imageUrl, name, variants = [], combos = [], link, childItems = [], tags = [], }, className, }) => {
    const [comboOpen, setComboOpen] = useState(false);
    const isCombo = childItems.length > 0;
    const toggleCombo = () => {
        setComboOpen((prev) => !prev);
    };
    const image = isCombo ? (React.createElement(ComboImage, { images: getComboImageUrl(childItems) })) : (React.createElement(Image, { height: 80, width: 80, src: imageUrl, alt: "product" }));
    const productName = isCombo ? getComboName(childItems) : name;
    return (React.createElement(Wrapper, { className: className },
        React.createElement(CustomLink, Object.assign({}, link), image),
        React.createElement(Right, null,
            React.createElement(CustomLink, Object.assign({}, link),
                React.createElement(Body, { hoverColor: "primary500", level: 1, color: "textPrimary", weight: "regular", line: 2 },
                    tags && tags.length > 0 && (React.createElement(React.Fragment, null,
                        React.createElement(Tag, { type: "secondary", variant: "branding", content: tags[0] }),
                        "\u00A0")),
                    productName)),
            sku && (React.createElement(Caption, { level: 1, color: "textSecondary" },
                "SKU: ",
                sku)),
            !!variants.length && React.createElement(Variants, { variants: variants }),
            !!combos.length && (React.createElement(StyledDropdown, { isOpen: comboOpen, toggle: toggleCombo, toggleType: "hover" },
                React.createElement(DropdownToggle, { toggleType: "hover" },
                    React.createElement(Action, { mgl: false }, "Xem combo")),
                React.createElement(DropdownMenu, { popperConfig: popperConfig, origin: "left top" },
                    React.createElement(ComboList, null, combos.map(({ imageUrl, name }, index) => (React.createElement(StyledGift, { key: index, image: {
                            src: imageUrl,
                        }, text: name }))))))))));
};
const Wrapper = styled.div `
  display: flex;
  gap: 12px;
`;
const Right = styled.div `
  flex: 1;
`;
const Action = styled.span(({ mgl = true }) => `
      font-size: 14px;
      color: #047fff;
      margin-left: ${mgl ? '1.5rem' : 0};
      cursor: pointer;
      display: inline-block;
      width: max-content;
      flex-shrink: 0;
    `);
const ComboList = styled.ul `
  padding: 0.25rem 0.75rem;
  list-style-type: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 0.5rem 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  background-color: white;
  margin: 0;
  width: max-content;
  max-width: 25rem;
`;
const StyledDropdown = styled(Dropdown) `
  width: max-content;
`;
const popperConfig = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [0, 10],
            },
        },
    ],
};
const StyledGift = styled(Gift) `
  margin: 0.5rem 0;
`;
const Image = styled(EnhancedImage) `
  border: 1px solid #e4e5f0;
`;

export { ProductInfo };
